export default __webpack_public_path__ + "static/media/cultural.c1c6d269.jpg";